// Custom valving fee guard (Charles, 2026-10-21). Kits that require custom valving go into the cart with the
// line property "Custom valving" (snippets/ms-custom-valving.liquid). This keeps the fee product's quantity
// equal to the number of those kits: adds it, puts it back if removed, follows quantity changes, and removes
// it when the kits are gone. Config comes from layout/theme.liquid as window.msValving = { feeId }.
(function () {
  var cfg = window.msValving;
  if (!cfg || !cfg.feeId) return;
  var PROP = 'Custom valving';
  var onCart = /^\/cart\/?$/.test(location.pathname);
  var running = null;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  // resolves true when the cart had to be corrected
  function sync() {
    if (running) return running;
    running = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var kits = 0, fee = 0;
        cart.items.forEach(function (it) {
          if (it.variant_id === cfg.feeId) fee += it.quantity;
          else if (it.properties && it.properties[PROP]) kits += it.quantity;
        });
        if (kits === fee) return false;
        var updates = {};
        updates[cfg.feeId] = kits;
        return post('/cart/update.js', { updates: updates }).then(function () { return true; });
      })
      .finally(function () { running = null; });
    return running;
  }

  // the theme's own cart calls (product page add, cart page quantity changes) go through jQuery
  if (window.jQuery) {
    jQuery(document).ajaxComplete(function (e, xhr, opts) {
      if (!/\/cart\/(add|change|update)/.test(opts.url || '')) return;
      sync().then(function (fixed) { if (fixed && onCart) location.reload(); });
    });
  }

  if (!onCart) return;
  sync().then(function (fixed) { if (fixed) location.reload(); });

  // Update / Checkout on the cart page: apply the typed quantities, correct the fee, then go on
  var form = document.querySelector('form.cart');
  var items = (window.cartObject && window.cartObject.items) || [];
  var involved = items.some(function (it) { return it.variant_id === cfg.feeId || (it.properties && it.properties[PROP]); });
  if (!form || !involved) return;
  form.addEventListener('submit', function (e) {
    var checkout = !!(e.submitter && e.submitter.name === 'checkout');
    e.preventDefault();
    var updates = [].map.call(form.querySelectorAll('[name="updates[]"]'), function (i) { return Number(i.value) || 0; });
    var note = form.querySelector('[name="note"]');
    var body = { updates: updates };
    if (note) body.note = note.value;
    post('/cart/update.js', body)
      .then(sync)
      .then(function () { if (checkout) location.href = '/checkout'; else location.reload(); })
      .catch(function () {
        // fall back to the plain form post rather than leave the shopper stuck
        if (checkout) { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; form.appendChild(h); }
        form.submit();
      });
  });
})();
